import { PermissionsEnum } from '@/auth/interfaces';
import { SaveUnidadesTransporte } from '../../shared/saveUnidadesTransporte';
import { useCheckPermissions } from '@/shared';

export interface CreateUnidadesTransportePageInterface {}

const CreateUnidadesTransportePage: React.FC<CreateUnidadesTransportePageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_add_unidadtransporte);

  return <SaveUnidadesTransporte titlePage="Crear Unidades de transporte" />;
};

export default CreateUnidadesTransportePage;
